import { render, staticRenderFns } from "./SkillsIcon.vue?vue&type=template&id=37511990&"
import script from "./SkillsIcon.vue?vue&type=script&lang=ts&"
export * from "./SkillsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports